// @ts-check
import { gql, useMutation } from '@apollo/client';
import { useDropzone } from 'react-dropzone';
import { useParams } from 'react-router-dom';

/**
 * @param {object} props
 * @param {import('@bottlebooks/graphql-server/src').DataImportType} props.type
 * @param {(result: import('./useUploadFile.generated').UploadDataImportFileMutation["result"]) => void} props.onUpload
 * @param {(file: File) => void} props.onDrop
 * @returns
 */
export default function useUploadFile({ type, onUpload, onDrop }) {
  const { workspaceId } = useParams();
  const [upload] = useMutation(UPLOAD_FILE);
  const dropzoneState = useDropzone({
    onDrop: async (acceptedFiles) => {
      const [file] = acceptedFiles || [];
      if (!file) return;
      if (onDrop) onDrop(file);
      const { data } = await upload({ variables: { workspaceId, file, type } });
      if (onUpload && data?.result) onUpload(data?.result);
    },
  });
  return dropzoneState;
}

/** @type {typeof import('./useUploadFile.generated').UploadDataImportFileDocument} */
export const UPLOAD_FILE = gql`
  mutation uploadDataImportFile(
    $workspaceId: ID!
    $file: Upload!
    $type: DataImportType!
  ) {
    result: uploadDataImportFile(
      input: { workspaceId: $workspaceId, file: $file, type: $type }
    ) {
      code
      success
      message
      file {
        fileId
        name
      }
    }
  }
`;
